/// <amd-module name="Artifacts/Npm/helpers/InstructionsHelper" />
import { IPackageVersion } from "Artifacts/Root/types";

export function getCopyInstallCommand(pkgName: string, pkgVersion: IPackageVersion): string {
  return `npm install ${pkgName}@${pkgVersion.version}`;
}
